export default {
  // actions:
  add: "Ajouter",
  cancel: "Annuler",
  delete: "Supprimer",
  edit: "modifier",
  exit: "Quitter",
  filter: "Filtre",
  import: "Importer",
  goBack: "Retour",
  logout: "Se déconnecter",
  next: "Suivant",
  previous: "Précédent",
  return: "Retour",
  save: "Enregistrer",
  search: "Recherche",
  signIn: "Connexion / Inscription",
  sortBy: "Trier par",
  upload: "upload",
  validate: "Valider",
  yes: "Oui",
  No: "Non",
  others: "Autres",
  countHours: "Nombre d'heures",
  //days of week
  monday: "lundi",
  tuesday: "mardi",
  wednesday: "mercredi",
  thursday: "jeudi",
  friday: "vendredi",
  day: "jour",
  // Messages:
  // [Info]
  contentModelDescription:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation",
  dragMessage:
    "Faites glisser et déposer un fichier ici, ou cliquez pour sélectionner le fichier à télécharger.",
  dropMessage: "Glisser-déposer pour changer l’ordre des onglets",
  importInProgress:
    "- L'import de l'emploi du temps est en cours. Veuillez patienter un instant ...",
  importTimeSheet: "Import d'emploi du temps de l'organization",
  notifUpdates: "Notifications de mises à jour",
  nothingFound: "Aucun résultat",
  nothingToShow: "Aucunes notification n'est diponible",
  noCollaboratorsMatches: "Aucun resultat retourné.",
  noBudget: "Aucun budget n'est importé pour cette organisation.",
  noTimeSheet: "Aucun emploi du temps n'est importée pour cette organisation.",
  noTimeSheetMatches: "Aucun resultat correspond a votre filtre.",
  noFinancialSheetMatches: "Aucun résultat ne correspond à votre filtre.",
  noOrganization: "L'organisation actuelle n'est pas encore activée !",
  searchNameorVATNumber: "Recherche par nom ou numéro de TVA",
  defaultDialogMessage: "Voulez-vous poursuivre ?",
  typesNoCategories: "Types de prestation non catégorisées",
  selectCategoriesMessage: "Désélectionnez pour exclure des catégories.",
  searchMessageCategories:
    "Tapez une catégorie pour l’attribuer à votre sélection",
  searchMessageValuations:
    "Tapez une classification pour l’attribuer à votre sélection",
  chooseMessageCategories:
    "Sélectionnez des éléments pour leur attribuer des catégories ou des classification",
  attentionArrivalDate:
    "Les statistics sont calculé à partir de la date d'arrivée du collaborateur ",
  attentionDepartureDate:
    "Les statistics sont calculé jusqu'a la date de départ du collaborateur ",
  attentionWorkingDates:
    "Les statistics sont calculé à partir de la date d'arrivée du collaborateur jusqu'à sa date de départ",
  validatePreviousLevels:
    "valider les deux premiers niveaux pour activer celui-ci",

  // [Confirmation]
  confirmationCategoriesTitle: "Confirmation d’attribution",
  confirmationCategoriesMessage:
    "Voulez-vous attribuer la catégorie à votre sélection ?",
  deleteCategoriesTitle: "Confirmation de dissociation",
  deleteCategoriesMessage: "Voulez-vous vraiment dissocier ce type ?",
  confirmationDeleteCategoryMessage:
    "Voulez-vous vraiment supprimer cette category?",
  confirmationDeleteSuperCategoryMessage:
    "Voulez-vous vraiment supprimer cette super category?",
  confirmationDeleteAnalysisPlanMessage:
    "Voulez-vous vraiment supprimer ce plan d'analyse?",
  confirmationDeleteValuationMessage:
    "Voulez-vous vraiment supprimer cette classification ?",
  confirmationDeleteCategoryTitle: "Confirmation de suppression",
  confirmationOverwriteTitle: "Confirmation de surcharge",
  confirmationForcedDeleteCategoryMessage: "Voulez-vous forcer la suppression?",
  confirmationForceDeleteCategoryTitle: "Erreur de suppression",
  confirmationOverWriteCategoriesMessage:
    "Voulez-vous vraiment ecraser la repartition du total actuel?",
  confirmationForceUpdateCategoryTitle: "Erreur de modification",
  confirmationForcedUpdateCategoryMessage:
    "Voulez-vous vraiment ecraser la facturabilité des prestations associés?",

  // [Confirmation]
  confirmationDeleteRoleTitle: "Confirmation de suppression",
  confirmationDeleteRoleMessage:
    "Voulez-vous supprimer le rôle à votre sélection ?",
  confirmationDeleteZoneTitle: "Confirmation de suppression",
  confirmationDeleteZoneMessage:
    "Voulez-vous supprimer la zone à votre sélection ?",
  confirmationDeleteBuTitle: "Confirmation de suppression",
  confirmationDeleteBuMessage:
    "Voulez-vous supprimer la BU à votre sélection ?",
  confirmationDeleteRegimeTitle: "Confirmation de suppression",
  confirmationDeleteRegimeMessage:
    "Voulez-vous supprimer le régime à votre sélection ?",
  confirmationDeleteHolidayTypeTitle: "Confirmation de suppression",
  confirmationDeleteHolidayTypeMessage:
    "Voulez-vous supprimer le type à votre sélection ?",
  confirmDeleteTasksMessage:
    "Certains préstations appartenant a l'interval des dates du fichier a importer sont déjà enregistrés, voulez-vous les ecraser ?",
  NoAffected: "NON-AFFECTÉ",
  nonAffected: "non affected",
  titleModalRegime: "Créer ou modifier les régimes",
  titleModalHolidayType: "Créer ou modifier les types de congés",
  titleModalRole: "Créer ou modifier les roles",
  titleModalLocalization: "Créer ou modifier les localisations",

  // [Success]
  importSuccess: "Import réussie",
  importTimeSheetSuccess: "Import du timesheet avec succès",
  operationCompleted: "Action réalisée avec succès",
  successfulAction: "Action réussie",
  correlateTaskTypeSuccess: "Correlation réussie",

  // [Error]
  error: "Erreur",
  errorOccured: "Une erreur est survenue, essayez plus tard.",
  incorrectFile: "Le fichier importé est incompatible !",
  incompatibleModel: "Le fichier importé ne correspond pas au model choisis !",
  fileSize:
    "La taille du fichier importé est insupportable, veuillez importer un fichier avec 800 lignes au maximum!",
  incompleteOperation:
    "Impossible de terminer l'opération, des données incorrectes ont été soumises",
  lostMessage: "Vous avez navigué si vite et vous êtes perdu...",
  noResult: "Oups, Aucun résultat ne correspond à votre recherche",
  Oops: "Oups",
  pageNotFound: "Cette page n'a pas pu être trouvée!",
  collaboratorNotArrivedYet:
    "le collaborateur n'était pas recruté à la date d'analyse selectionnée",
  collaboratorHasLeft:
    "le collaborateur a quitté l'établissement à la date d'analyse selectionnée",
  collaboratorNeedConfiguration:
    "le collaborateur a besoin d'une configuration avant d'accéder a ses statistiques",

  // Label
  chooseERP: "Choisir l'ERP",
  communities: "Communautés",
  capacityPlaning: "Capacité Planning",
  dateRange: "plage de dates",
  endDate: "Date de fin",
  profile: "Profil",
  settings: "Paramètres",
  startDate: "Date de début",
  diagram: "Schéma",
  to: "au",
  recentActivities: "activitées récentes",
  noActivities: "Aucune activitée",
  relizedDuration: "Temps réalisé",
  folder: "Dossier",
  cycleLabel: "Schéma du tableau",
  TAMTAMApplications: "Applications TAMTAM",
  manageTasks: "Gérer les prestations",
  categories: "Catégories",
  noCategory: "Hors catégorie",
  noValuation: "Hors classification",
  allCategories: "Tous les categories",
  clientGroup: "Groupe client",
  client: "Client",
  collaboratorList: "liste des collaborateurs",
  collaboratorSpace: "Espace collaborateur",
  collaborator: "Collaborateur",
  collaborators: "Collaborateurs",
  clientsFolders: "dossiers clients",
  taskCategory: "Categorie de prestation",
  periodeType: "Type de periode",
  datePeriod: "Periode des dates",
  attribution: "Attribution",
  timeAchieved: "Temps réalisés",
  statistics: "Statistiques",
  allClients: "Tous les dossiers",
  myClients: "Mes dossiers",
  otherClients: "Les autres dossiers",
  collaboratorsSettings: "Gestion collaborateurs",
  categorySettings: "gestion categories",
  setBudgetGlobal: "saisir le budget global",
  name: "Nom",
  regime: "Regime",
  role: "Role",
  grade: "niveau de seniorité",
  roleOnFolder: "Role sur dossier",
  folderManager: "Gestionnaire de dossier",
  caAdjusted: "CA Personnel",
  benchmarkEffectif: "Benchmark Effectif",
  benchmarkBudgetaire: "Benchmark Budgetaire",
  annualCapacity: "Capacité annuelle",
  NFHr: "Heures non facturables",
  backup: "Binôme",
  regimes: "Regimes",
  annualH: "Heures annuel",
  basicFH: "Heures F annuelle",
  basicNFH: "Heures NF annuelle",
  specialProject: "NF Special projet",
  nbrWeeks: "Nombre de semaine",
  RHHebdo: "RH Hebdo",
  hrForWeek: "Heures par semaine",
  hrForYear: "Heures par an",
  total: "Total",
  solde: "Solde",
  arrivalDate: "date d'arrivée",
  departureDate: "date de départ",
  selectDate: "selectionner une date",
  selectZone: "selectionner une zone",
  selectBu: "selectionner une bu",
  selectRole: "selectionner un role",
  selectRegime: "selectionner un regime",
  selectProfile: "selectionner un profil",
  selectPartner: "selectionner un partner",
  enterSpecialProject: "saisir le special projet",
  asClientManager: "étant GD",
  asEncodingDelegate: "étant GE",
  asSupervisor: "étant superviseur",
  nonBillableAdmittedQP: "NFA proratisé",
  annualAffectedBudgetQP: "AAB proratisé",
  realAffectedBudgetQP: "budget réel proratisé",
  analyseDate: "Date d'analyse",
  dossierCount: "Nombre dossiers",
  budgeted: "Budgetisés",
  nonBudgeted: "Non-budgetisés",
  remainingBudget: "Budget restant à affecter",
  usualBillable: "Facturable attendu",
  billable: "Facturable réel",
  usualNonBillable: "Non facturable permis",
  nonBillable: "Non facturable réel",
  spreadPositive: "Spread+",
  spreadNegative: "Spread-",
  involvement: "involvement",
  clearing: "Clearing",
  shortfall: "Shortfall",
  shortage: "Shortage",
  diffNonBillable: "Différence non-facturable",
  localisation: "Localisation",
  businessUnit: "Unité business",
  zones: "Zones",
  zone: "Zone",
  bu: "BU",
  squad: "Squad",
  baseOn: "a la base du",
  clonerFrom: "cloner depuis",
  forYear: "pour l'année",
  budgetCloned: "Budget cloné",
  cloneSuccess: "clone réussie",
  selectRegimeMessage: "Veuillez sélectionner un régime",
  desactivateDelegation: "Désactiver la delegation et réinitialiser le budget",
  activateDelegation: "Activer la delegation",
  addNewDelegated: "ajouter un nouveau collaborateur delegué.",
  effectiveBenchmark: "Benchmark effective",
  normalizedBenchmark: "Benchmark normalisé",
  remainingHours: "Heures restante",
  realizedHours: "Heures réalisés",
  extraTimeSuccess: "extra-temps favorable",
  extraTimeWarning: "extra-temps douteux",
  extraTimeDanger: "extra-temps critique",
  affectedBudget: "Budget affecté",
  realizedBudget: "Budget réalisés",
  extraBudget: "Extra budeget",
  nonBillableHours: "non-facturables",
  billableHours: "facturables",
  //Comments
  overloadCollaborator: "Une surcharge d'heure pour ce collaborateur de %xh",
  clientOutBudget:
    "Avec une intervention sur %x dossiers autre que ceux budgétisés",
  overloadNonBillable:
    "Un depassement des heures non facturable de %xh est enregistré",
  almostNonBillable:
    "Le compte proratisé du non facturable risque d'etre soldé, il reste %xh",
  greatProgressARC:
    "un engagement trés interressant avec un %x heures de plus prp a son budget annuel proratisé",
  acceptedProgressARC:
    "un engagement remarquable avec un retard negligeable de %x heures prp a son budget annuel proratisé",
  warningProgressARC:
    "un engagement inquiétant avec un retard de %x heures prp a son budget annuel proratisé",
  alertProgressARC:
    "un engagement presque absent avec un retard de %x heures prp a son budget annuel proratisé",
  greatProgressCRC:
    "un engagement trés interressant avec un %x heures de plus prp a sa capacité annuelle proratisée",
  acceptedProgressCRC:
    "un engagement remarquable avec un retard negligeable de %x heures prp a sa capacité annuelle proratisée",
  warningProgressCRC:
    "un engagement inquiétant avec un retard de %x heures prp a sa capacité annuelle proratisée",
  alertProgressCRC:
    "un engagement presque absent avec un retard de %x heures prp a sa capacité annuelle proratisée",
  overNinety: "Coefficient inférieur a 90%",
  underNinety: "Coefficient supérieur a 90%",
  releasedOverUsualBillable: "Facturable réalisé dépasse l'habituel",
  releasedUnderUsualBillable: "Facturable réalisé ne couvre pas l'habituel",
  overWriteCategories:
    "Vous risquer d'écraser la repartition par categorie ou par delegation en validant cette valeur",
  overWriteDelegations:
    "Vous risquer d'écraser la repartition par delegations en validant cette valeur",

  // Titles
  PrestaTs: "Presta-ts",
  budgetH: "Budget H",
  BudgetEco: "Budget €",
  budgetEco: "Budget €",
  Caution: "Avertissement",
  budget: "Budget",
  clientList: "liste des clients",
  productionCapacityPlanning: "Capacité planing production",
  detailedBudget: "Budget détaillé de :",
  toDate: "à la date",
  fromDate: "du",
  MyTimeSheet: "Gestion du temps",
  taskTypesSettings: "Gestion préstations",
  subTitleCapacityPlanningProduction: "VUE CAPACITÉ PLANING GÉNÉRALE",
  subTitleTimeSheet: "VUE ETAT DE SANTE FINANCIER",
  subTitleBudgetSheet: "VUE ETAT DU SITUATION BUDGETAIRE",
  subTitleClientList: "VISUALISER ET GÉRER VOS DOSSIER CLIENTS",
  subTitleCategoryStatistics: "Incenderat autem audaces usque ad insaniam",
  UpdateCollaboratorSettingTitle: "Gestion des paramétres collaborateur",
  UpdateCollaboratorSetting: "Gérer les paramétres du collaborateur",
  ProfilCollaboratorSetting: "Profile du collaborateur",
  removeSuccess: "Suppression réussi",
  saveSuccess: "Sauvgarde réussi",
  configBudget: "gérer budget",
  rolesList: "Liste des rôles",
  typesList: "Liste des types",
  zonesList: "Liste des zones",
  busList: "Liste des BU",
  createRole: "Créer rôle",
  createType: "Créer type",
  updateRole: "Modifier rôle",
  updateType: "Modifier type",
  roleCreated: "Rôle crée",
  holidayTypeCreated: "Type de congé crée",
  zoneCreated: "Zone crée",
  buCreated: "Unité business crée",
  roleUpdated: "Rôle modifié",
  holidayTypeUpdated: "Type de congé modifié",
  zoneUpdated: "Zone modifié",
  buUpdated: "Unité business modifié",
  roleDeleted: "Rôle supprimé",
  holidayTypeDeleted: "Type de congé supprimé",
  zoneDeleted: "Zone supprimé",
  buDeleted: "Unité business supprimée",
  regimesList: "Liste des régimes",
  createRegime: "Créer régime",
  updateRegime: "Modifier régime",
  updateZone: "Créer zone",
  createZone: "Modifier zone",
  updateBu: "Créer BU",
  createBu: "Modifier BU",
  regimeCreated: "Régime crée",
  regimeUpdated: "Régime modifié",
  regimeDeleted: "Régime supprimé",
  collaboratorUpdated: "collaborateur modifié",
  manageBudget: "GÉRER LE BUDGET :",
  budgetSettingOf: "Gestion budgetaire de",
  manageBudgetClient: "Gérer le budget dossier",
  title: "Titre",
  AssociatedWith: "Associée à",
  classified: "Classifiée",
  BelongsTo: "Appartient à",
  KPIEvaluation: "Evaluation KPI",
  budgetSetting: "Gestion budget",
  topfolders: "Top dossiers",
  flopfolders: "Flop dossiers",
  topprogressions: "Top progressions",
  flopprogressions: "Flop progressions",
  budgetedFolders: "est attribué",
  handledFolders: "intervient",
  notifyUsingUa:
    "Attention : Ce lien ne sera plus fonctionnel. Veuillez se connecter via ce lien: ",
  needToUploadAttachments: "Besoin de fournire les pièces justifiantes",
  // Enumeration
  ACTIVATED: "ACTIVÉ",
  DEACTIVATED: "DÉSACTIVÉ",
  NOT_CONFIGURED: "NON CONFIGURÉ",
  PENDING: "EN ATTENTE",
  READY: "PRÊT",

  CLIENT_GROUP: "Groupe de client",
  CLIENT: "Client",
  TASK_TYPE: "Type de prestation",
  COLLABORATOR: "Collaborateur",

  french: "Français",
  english: "Anglais",
  dutch: "Néerlandais",

  month: "mois",
  quarter: "trimestre",
  semester: "semestre",
  year: "année",

  today: "Aujourd'hui",
  yesterday: "Hier",
  otherday: "Avant-hier",
  week: "la semaine",

  monthly: "Mensuel",
  current: "Courant",
  annual: "Annuel",

  CapacityAnnual: "Capacité annuelle",
  NonBillableAdmitted: "Non facturable admis",
  AnnualAffectedBudget: "Budgets annuels affectés",
  OutBudgetCompletion: "Complétion hors budget",
  BudgetaryAvailability: "Disponibilité budgétaire",
  CapacityAnnualQP: "État de la capacité annuelle",
  NonBillableSaved: "État du non facturable enregistrée",
  AnnualReleasedCompletion: "Complétion budgétaire annuelle réalisée",
  CurrentReleasedCompletion: "Complétion budgétaire courante réalisée",
  BillableCoefficient: "Coefficient facturable courant",
  BillableNFCoefficient: "Coefficient NF",

  frenchTitle: "Titre Français",
  coefficient: "Coefficient",
  englishTitle: "Titre Anglais",
  dutchTitle: "Titre Néerlandais",
  addCategory: "Ajouter une catégorie",
  addAnalysisPlan: "Ajouter un plan d'analyse",
  addSuperCategory: "Ajouter une super catégorie",
  typeTitleCategory: "Tapez le titre de votre catégorie (3 langues disponible)",
  typeTitleAnalysisPlan:
    "Tapez le titre de votre plan d'analyse (3 langues disponible)",
  typeTitleSuperCategory:
    "Tapez le titre de votre super catégorie (3 langues disponible)",
  typeTitleValuation:
    "Tapez le titre de votre valuation (3 langues disponible)",
  classification: "Classification",
  attachedClients: "Clients attachés",
  addCategories: "Ajoutez vos catégories",
  manageCategories: "Gérer les catégories",
  categoriesList: "Liste des catégories",
  tasksList: "Liste des préstations",
  assignCategorie: "Assigner les préstations aux catégories",
  categoryUpdated: "Catégorie mise à jour",
  ValuationUpdated: "Classification mise à jour",
  categoryAdded: "Catégorie ajoutée",
  ValuationAdded: "Classification ajoutée",
  categoryDeleted: "Catégorie supprimée",
  ValuationDeleted: "Classification supprimée",
  selectCommunity: "choisissez votre communauté",
  listCommunity: "Liste des communautés membre",
  CommunityUnauthorised: "Cette communauté n’a pas d'accès à cette application",

  CLIENT_MANAGER: "Gestionnaire de dossier",
  ENCODING_DELEGATE: "Gestionnaire d'encodage",
  RESPONSIBLE: "Responsable",
  DELEGATED: "Delegué",
  allFiles: "Tous les dossiers",
  myFolders: "Les dossiers en tant que Résponsable",
  otherFolders: "Les dossiers en tant que Délégué",
  supervisorFolders: "Les dossiers en tant que Superviseur",
  orphanFolders: "Les dossiers Orphelin",
  tableView: "Vue chiffrée",
  graphicView: "Vue graphique",
  Categories: "Catégories",
  SuperCategories: "Super Catégories",
  AnalysesPlan: "Plan d'analyse",
  SuperCategory: "Super catégorie...",
  AnalysisPlan: "Plan d'analyse...",
  Untreated: "Non traité",
  Little_treated: "Peu traité",
  All: "Tous",
  Normal: "Normal",
  Overtaking: "Dépassement",
  WorkingHoursPerDay: "Heures de travail par jour",
  NumberOfDays: "Nombre de jours",
  OvertakingHours: "Attention vous avez un dépassement de: ",
  CongeAnciennete: " congé d'ancienneté",
  TimeLeft: "Nombre d'heures restantes à affecter: ",

  collaboratorNotLinkedToAnyZone: "Collaborateur non lié à une zone.",
  pleaseAssignHimAZoneBeforeSettingUpHisCalendar:
    "Veuillez lui attribuer une zone avant de configurer son calendrier.",
  pleaseConfigureTheCompanysAnnualCalendarBefore:
    "Merci de configurer le calendrier annuel de la société avant de celui du collaborateur.",
  AnnualCalendarNotFound: "Calendrier annuel introuvable.",
  calendarSettings: "Gestion de calendrier",
  holidays: "Fériés",
  annualHolidays: "Congé annuel",
  workingDays: "Ouvrable",
  paidVacations: "Congé payé",
  partialVacations: "Congé partiel",
  othersVacations: "Autres congés",

  independentVacation: "Congé independant",
  paidVacation: "Congé payé",
  myVacations: "Mes congés",
  ManageTheCollaboratorsCalendar: "Gérer le calendrier du collaborateur.",
  ManageMyCalendar: "Gérer mon calendrier et mes congés",
  ManageTheAnnualCalendarOfYourFiduciary:
    "Gérez le calendrier annuel de votre fiduciaire",
  confirmationDeleteCalendarConfigMessage:
    "Êtes-vous sûr de vouloir supprimer cette configuration?",
  Calendar: "Calendrier",
  ManageTheCollaboratorsInformation:
    "Gérez les informations des collaborateurs",
  FinancialStatement: "Etat financier",
  subTitleFinancialSheet: "VUE DÉTAILLÉE DE LA SANTÉ FINANCIÈRE",

  myCalendar: "Mon Calendrier",
  noAnnualCalendar: "le calendrier annuel de l'année",
  annualCalendarNotConfig: "n'est pas encore configuré",
  advancedConfig: "Configuration avancée",
  enterHourlyBudget: "Entrer le budget horaire",
  enterEconomicBudget: "Entrer le budget économique",
  saveAndNext: "Enregistrer et Suivant",

  searchByName: "Recherche par nom",
  Active: "Actif",
  "Not configured": "Non Configuré",
  "Not active (left)": "Non actif (parti)",
  "collaborator state": "État/status du collaborateur",

  importedFrom: "Importé depuis",
  identifier: "identifiant",
  selectCollaborator: "veuillez sélectionner au moins un collaborateur",
  entiteFiltre: "Entité (clients associés à: )",
  analysis: "Analyse",
  details: "Détails",
  entite: "Entité",

  clientType: "Type de clients",
  attache: "Attaché",
  tous: "Tous",
  entiteType: "Entité",

  configureClassesMessage:
    "Veuillez configurer les classes de valeurs ajoutées",
  analysisRealisedHours:
    "Analyses des heures réalisées sur la valeur ajoutée :",
  MoreDetails: "Plus de détails",

  descriptionAnnualFolder: `Ce tableau considère ici les budgets et le réalisé sur une base annuelle`,
  descriptionCurrentFolder: `Ce tableau considère ici les budgets et le réalisé sur une base proportionnelle, c-à-d en tenant compte d’un budget<br/>réparti uniformément toute l’année et de la date de synchronisation courante`,
  realized: "Réalisé",

  globalBudgetAffected: "Budget global affecté",
  globalBudgetNotAffected: "Non budgétisé",
  budgetByZoneAffected: "Budget par zone affecté",
  budgetZoneDelegationAffected: "Budget délégation affecté",
  budgetZoneByCategoryNotCompleted: "Budget par catégorie non terminée",
  delegationNotAffected: "Délégation non affecté",
  budgetCompleted: "Budget complété",
  profit: "Chiffre d'affaire",
  budgetaryBenchmark: "Benchmark Budgétaire",
  benchmark: "Benchmark effective",
  sum: "Somme",
  Belgique: "Belgique",
  Maroc: "Maroc",
  effectiveRate: "Taux effectif",
  budgetaryRate: "Taux budgétaire",
  and: "et",
  more: "d'autres clients ",
  globalBudgetLeft: "Budget global restant",
  surpassedBudget: "Vous avez dépassé le budget global",
  overwrittenZoneBudget: "Vous risquez d'écraser le budget de la zone",
  insufficientZoneBudget: "Budget de zone insuffisant",
  insufficientGlobalBudget: "Budget global insuffisant",
  dataDelegatedCollaboratorRequired:
    "Les données déléguées par le collaborateur sont requises",

  SUPERADMIN: "Super Admin",
  ADMIN: "Administrateur",
  USER: "Utilisateur",
  NONE: "Aucun",
  EDITOR: "Éditeur",
  LEGAL_REPRESENTATIVE: "Représentant légal",
  OFFICIAL: "Collaborateur",
  EXTERNAL: "Externe",
  MANAGER: "Manager",
  PARTNER: "Partner",
  roles: "Rôles",
  "Accounting roles": "Rôles Accounting",
  "Organization roles": "Rôles organisation",
  "Apply authorization to selected users":
    "Appliquer l'autorisation aux utilisateurs sélectionnés",
  Apply: "Appliquer",
  "New user": "Nouveau utilisateur",
  "Select All": "Tout sélectionner",
  "Deselect All": "Tout déselectionner",
  Preferences: "préférences",
  "associate privileges": "privilèges association",
  clientsPrivileges: "Privilèges Liste Clients",
  collaboratorsPrivileges: "Privilèges Collaborateurs",
  prestationsPrivileges: "Privilèges Prestations",
  cpPrivileges: "Privilèges Capacity Planning",
  generalPrivileges: "Privilèges Générales",
  BudgetPrivileges: "Privilèges Budget",
  gestionPlansPrivileges: "Pivilèges Gestion des Plans",
  accessClientList: "Autoriser l'accès à la liste de client",
  activateNotifications: "Activer les notifications",
  activateCalendarNotifications: "Activer les notifications calendrier",
  activateCarteNotifications: "Activer les notifications carte [Dev/Cor]",
  allowConfigurateBudget: "Autoriser la configuration du budget",
  allowUpdateClientSettings:
    "Autoriser la modification des paramètres du client",

  allowUpdatingBillingView:
    "Autoriser la modification du voyant de facturation",
  allowUpdatingTarifClients: "Autoriser la modification  des tarifs clients",
  allowUpdatingNewClients: "Autoriser la modification d'un nouveau client ",
  allowUpdatingDepartClients: "Autoriser la modification du depart client",

  allowAccessToClientCollaboratorRelation:
    "Autoriser l'acces aux relations liées",
  allowAccessToCorrectionCards: "Autoriser l'acces aux cartes de corrections",
  allowAccessToStatisticsCards: "Autoriser l'acces aux cartes Statistics",
  allowVisualizationOfBudgetedTime:
    "Autoriser la visuatlisation du temp budgetisé",
  allowVisualizationOfBudgetedBenchmark:
    "Autoriser la visuatlisation du volumetry budgetisé ",
  allowVisualizationOfRealizedTime:
    "Autoriser la visuatlisation du temp realiser",
  allowVisualizationOfRealizedBenchmark:
    "Autoriser la visuatlisation du volumetry realisé",
  allowAccessToClientInformations: "Autoriser l'access aux informations client",
  allowAccessToGlobalBudget: "Autoriser l'access au Budget Global",
  allowUpdatingOffrePrice: "Autoriser la modification du prix",
  allowToAddDeleger: "Autoriser l'ajout delegé",
  allowUpdateBudgetedBenchmark: "Autoriser la modification du budget volumetry",

  allowAdjustDistributionOfTasksByRole:
    "Autoriser l'ajustement de Distribution des taches par Role",
  allowAttributionBU: "Autoriser la Distribution des BU",
  allowAttributionSquad: "Autoriser la Distribution des Squad",
  allowCollabToDevCard:
    "Autoriser la création des cartes de développement pour les collab",
  allowAttributionCluster: "Autoriser la Distribution des Cluster",
  allowSelectAppliedModel: "Autoriser la selection des models appliquer",
  allowDragFromToDo: "Autoriser glisser-déposer à partir de 'A faire'",
  allowDragFromWIP: "Autoriser glisser-déposer à partir de 'En Cours'",
  allowDragFromDone: "Autoriser glisser-déposer à partir de 'Terminé'",
  allowDragFromValidate:
    "Autoriser glisser-déposer à partir de 'En Validation'",

  allowAccessClientSpace: "Autoriser l'access a l'espace client",
  allowAccessCollaboratorList: "Autoriser l'acces a la liste collaborateur",
  allowAccessPlanification: "Autoriser l'accès à Planification",
  allowAccessFolderCapacity: "Autoriser l'accès à Capacité Dossier",
  allowAccessFinancialState: "Autoriser l'accès à l'Etat Financier Personnel",
  allowVerifyBudget: "Autoriser la vérification du budget",
  allowCreateCorrectionCards: "Autoriser la creation de la carte de correction",
  "Allow associate dashboards": "Autoriser l'association des dashboard",
  reportingPrivileges: "Privilèges Reporting",
  allowAccessReporting: "Autoriser l'accès à la page Reporting",
  allowAccessReportingTab: "Autoriser l'accès à Reporting",
  allowAccessProdCapacity: "Autoriser l'accès à Suivi de Production",
  allowAccessBonusPlan: "Autoriser l'accès à Plan de Bonus",
  allowAccessEcheance: "Autoriser l'accès à Suivi d'Echéances",
  allowAccessBalanceRecap: "Autoriser l'accès à Récapitulatif Bilans",
  allowAccessCardsStatistics: "Autoriser l'accès aux cartes statistiques",
  allowAccessCalendar: "Autoriser l'accès à Calendrier",
  allowValidateVacationRequest: "Autoriser la validation des demandes de congé",
  allowAccessTimeReport: "Autoriser l'accès à Suivi du Temps",
  allowAccessPortfolio: "Autoriser l'accès à Suivi des Portefeuilles",
  allowAccessErrReporting: "Autoriser l'accès à Supervision",
  allowAccessVacationMatrix: "Autoriser l'accès à Matrice de Congé",
  allowAccessPlans: "Autoriser l'accès à Suivi des Plans",
  allowAccessPrestation: "Autoriser l'accès à Suivi des Prestations",
  financialPrivileges: "Privilèges Financier",
  allowAccessFinancial: "Autoriser l'accès à la page Financial",
  allowAccessFinancialSheet: "Autoriser l'accès à Financial Sheet",
  allowAccessForfait: "Autoriser l'accès à Forfait",
  allowAccessCroissance: "Autoriser l'accès à Croissance",
  allowAccessPrestaTS: "Autoriser l'accès à la page Presta TS",
  allowAccessDynamicTab: "Autoriser l'accès à la page Table Dynamique",
  supPrivileges: "Privilèges Supplémentaires",
  capPlanPrivileges: "Privilèges Capacity Planning",
  allowAccessCapPlan: "Autoriser l'accès à la page Capacity Planning",
  allowAccessCapPlanTab: "Autoriser l'accès à Capacity Planning",
  allowAccessSynt: "Autoriser l'accès à Synthèse",
  settingPrivileges: "Privilèges Paramétrage",
  notificationPrivileges: "Privilèges Notifications",
  timesheetPrivileges: "Privilèges Timesheet",
  allowAccessSetting: "Autoriser l'accès à Settings",
  allowAccessCategories: "Autoriser l'accès à la page Gestion Categories",
  allowAccessTaskTypes: "Autoriser l'accès à la page Gestion Task Types",
  allowAccessCollaborators:
    "Autoriser l'accès à la page Gestion Collaborateurs",
  allowAccessCalendarSet: "Autoriser l'accès à la page Gestion Calendrier",
  allowCoeffConfigSet:
    "Autoriser l'accès à la gestion des coefficients software",
  allowAccessModels: "Autoriser l'accès à la page Gestion Modeles",
  allowAccessUsers: "Autoriser l'accès à la page Gestion Utilisateurs",
  allowAccessSynchronization: "Autoriser l'accès à la page Synchronisation",
  allowCoefficientsConfig:
    "Autoriser la configuration des coefficients des logiciels",
  allowAccessParameters: "Autoriser l'accès à la page Gestion Paramétres",

  Processing: "Traitement en cours",
  "Successfully updated": "Mise à jour réussie",
  authorizations: "autorisations",
  users: "Utilisateurs",
  user: "Utilisateur",
  editor: "Éditeur",
  admin: "Administrateur",
  manager: "Manager",
  partner: "Partner",
  rejectReason: "raison de rejet",
  "Search by name": "Recherche par nom",
  "Search by name or erp id": "Recherche par nom ou erp id",

  myCollaboratorSpace: "Mon espace collaborateur",

  applicationNotActivated:
    "L'application Power Team n'est pas Activée pour l'organisation actuelle.",
  accountingNotActivated:
    "L'application Accounting n'est pas Activée pour l'organisation actuelle.",
  applicationNotActivatedIndication:
    "Pour plus d'informations sur ce produit, merci de nous consulter.",
  about_us_content: `est une suite d'outils qui permet à une communauté de communiquer, partager, organiser ou  collaborer efficacement.  La plateforme est équipée de diverses applications assemblées selon les besoins par le client.  Grace  à nos outils mutualisés, nos clients disposent des dernières technologies sans devoir en assurer le développement au profit de leur core business.`,
  "You don't have the rights for the requested operation":
    "Vous n'avez pas les droits pour l'opération demandée",
  totalCollaboratorFolderInfo:
    "il se peut qu'un collaborateur travaille sur le même dossier avec des rôles différents, ce qui signifie que le total n'est pas toujours égal la somme des quatre colonnes des dossiers.",

  budgetGlobal: "Budget global",
  affectationBudgetaire: "Affectation budgétaire",
  budgetParCat: "Budget par Catégorie",
  attributionBudgetaire: "Attribution budgétaire",
  update: "Mise à jour",
  budgetUpdated: "Le budget a bien été mis à jour.",
  errorUpdatingBudget: "Erreur inconnue lors de la mise à jour du budget.",
  parametersUpdated: "Paramètres mis à jour",
  parameterSettings: "Gestion des paramètres",
  parameterSettingsParameterBenchmark:
    "Activez ou désactivez la synchronisation et gérer le paramètre de la fiduciaire",
  parameterBenchmark: "Gérer le paramètre de la fiduciaire",
  parameterSynchronization: "Paramètre de synchronisation",
  parameterOrganization: "Paramètre de la fiduciaire",
  parameterAuth: "Paramètre d'autorisations",
  manageRolesCollaboratorsOnFiles:
    "Gestion des roles des collaborateurs sur les dossiers",
  encodingManager: "Gestionnaire d'encodage",
  supervisor: "Superviseur",
  scanOperator: "Scan operateur",
  encodingSupervisor: "Superviseur d'encodage",
  manageRole: "Gestion Role",
  manageEntity: "Gestion Entité",
  ManageClientEntityRelationships: "Gestion des relations clients entités",
  annualBenchmark: "Benchmark annuel",
  enterAnnualBenchmark: "Entrer le benchmarque annuel",
  messageInfoSynchronization:
    "L'activation de la synchronisation implique que la gestion des Entités et/ou les Roles ne seront plus accessible depuis Power Team, et pour faire des modifications vous devez passer par votre ERP.",
  messageInfoBenchmark:
    "Si vous ne précisez pas ce paramètre, la valeur du benchmark utilisée par défaut est de 70.",
  dynamicTable: "Tableau Magique",
  all: "Tout",
  unbudgeted: "Non budgétisé",
  inProgress: "En cours",
  advanced: "Avancé",
  budgetedState: "Budgétisé",
  unknown: "Inconnu",
  SUPERVISOR: "Superviseur",
  StatusBudgEco: "Statut budgétaire économique",
  StatusBudgHoraire: "Statut budgétaire horaire",
  budgetEcoManquant: " Budget économique non affecté",
  Export: "Exporter",
  Import: "Importer",
  importFinancialSheet: "Importer etat financier",
  importFinancialSheetSuccess: "Import du etat financier avec succès",
  importFinancialContentModelDescription:
    "Veuillez vérifier que votre fichier Excel contient les colonnes suivantes",
  SUPERVISOR_ZERO_WARNING: "Superviseur sans budget",
  SUPERVISOR_NULL_WARNING: "Superviseur non affecté",
  RESPONSIBLE_NULL_WARNING: "Responsable non affecté",
  RESPONSIBLE_ZERO_WARNING: "Responsable sans budget",
  RESPONSIBLE_ZONE_WARNING: "Responsable avec zone erronée",
  GD_ZERO_WARNING: "GD sans budget",
  GD_NULL_WARNING: "GD non affecté",
  GE_ZERO_WARNING: "GE sans budget",
  GE_NULL_WARNING: "GE non affecté",
  SE_ZERO_WARNING: "SE sans budget",
  SE_NULL_WARNING: "SE non affecté",
  SCAN_OP_ZERO_WARNING: "Scan op sans budget",
  SCAN_OP_NULL_WARNING: "Scan op non affecté",
  DELEGATION_ZERO_WARNING: "Délégué sans budget",
  DELEGATION_NULL_WARNING: "Délégué non affecté",
  DELEGATION_ZONE_WARNING: "Délégé avec zone erronée",
  UNBALANCED_BUDGET: "Budget déséquilibre",
  monAgenda: "Mon agenda",
  myBirthdays: "Mes anniversaires",
  noEvent: "Aucun événement",
  calendrier: "Calendrier",
  explorer: "Explorer",
  cumulated: "cumulé",
  nonCumulated: "non cumulé",
  individual: "individuel",
  collective: "collectif",
  taskTypeUpdated: "type de tâche modifié",
  isBillable: "Facturable ",
  individualScore: "score individuel",
  collectiveScore: "score collectif",
  organizationScore: "score fudiciaire",
  REJECTED: "Rejeté",
  APPROVED: "Approuvé",
  rejectionMessage: "Voulez-vous vraiment rejeter ce congé ?",
  approvalMessage: "Voulez-vous vraiment approuver ce congé ?",
  NonBudgetise: "Ce client ne peut pas être budgestisé !",
  regimeVAT: "Régime TVA",
  closingDate: "Date clotûre",
  totalBudget: "Budget Total",
  belgiumBudget: "Budget BE",
  moroccoBudget: "Budget MA",
  SCAN_OP: "SCAN OP",
  deleted: "supprimé",
  persistent: " persistant",
  clientState: "Etat client",
  selectedRole: "Rôle selectionné",
  notCollaborator: "N'est plus collaborateur",
  se: "Superviseur d'encodage",
  folderNumber: "Nombre de dossiers",
  collaboratorNumber: "Nombre de collaborateurs",
  categoryNumber: "Nombre de catégories",
  userNumber: "Nombre d'utilisateurs",
  activate: "Activer",
  desactivate: "Désactiver",
  Budgeting: "Budgétisation",
  BudgetingInProgress:
    "- Budgétisation est en cours. Veuillez patienter un instant ...",
  ALL: "Tout",
  dashboardPrivileges: "Privilèges de Tableau de Bord",
  allowAccess: "Disponibilité de la page",
  viewDataBy: "Visualisation des données",
  viewPortfolioDataBy: "Visualisation de portefeuilles",
  allowConfigCollaborator: "Configuration du collaborateur",
  viewTimeSheetDataBy:
    "Visualisation des prestations timesheet d'autres collaborateurs",
  viewCPlanningDataBy: "Visualisation des chiffres d'autres collaborateurs",
  viewNotificationDataBy: "Recevoir les notification de",
  viewNotificationSupervisionDataBy:
    "Recevoir les notification de supervision d'autres collaborateurs",
  getValidationNotifSupervisionBy:
    "Recevoir les notification de validation des supervision d'autres collaborateurs",
  viewNotificationCalendarAttachmentRequestBy:
    "Recevoir les notification des demandes de pieces jointes des absences",
  viewNotificationSupervisionRepportDataBy:
    "Recevoir les notification des rapports de supervision d'autres collaborateurs",
  getNotificationAbsenceRequestBy:
    "Recevoir les notification des demandes d'absence des collaborateurs",
  getNotificationAbsenceStatusBy:
    "Recevoir les notification des status des congés des collaborateurs",
  getNotificationAbsenceAssignmentBy:
    "Recevoir les notification d'affectation des congés des collaborateurs",
  getNotificationAbsenceBuckupBy:
    "Recevoir les notification du backup des congés des collaborateurs",
  getNotificationSickLeaveBy:
    "Recevoir les notification des demandes de congé maladie des collaborateurs",
  viewNotificationTSReminderBy:
    "Recevoir les notification du rappel de saisi du time-sheet",
  viewNotificationCroissanceInBy:
    "Recevoir les notification des dossiers entrants",
  viewNotificationCroissanceOutBy:
    "Recevoir les notification des dossiers sortants",
  personal: "Personnel",
  partnership: "Partnership",
  allowAccessRevision: "Lancer une révision",
  allowAccessClientIn: "Autoriser l'accès à Clients IN",
  allowAccessClientOut: "Autoriser l'accès à Clients Out",
  allowAccessClientRisky: "Autoriser l'accès à Clients à Rique",
  allowAccessReview: "Autoriser l'accès à Review",
  allowAccessIndivDevBe: "Autoriser l'accès au Développement Individuel BE",
  allowAccessIndivDevMa: "Autoriser l'accès au Développement Individuel MA",
  noAccess: "Pas d'accès",
  fullAccess: "Accès Complet",
  deprecated: "Déprécié",
  priceList: "Liste de prix",
  price: "Prix",
  category: "Catégorie"
};



// WEBPACK FOOTER //
// ./src/i18n/fr.js